import { Link } from "react-router-dom"

type SMSConsentCheckboxProps = {
  checked: boolean
  onChange: (checked: boolean) => void
  disabled?: boolean
}

export function SMSConsentCheckbox({ checked, onChange, disabled = false }: SMSConsentCheckboxProps) {
  return (
    <div
      style={{
        background: "rgba(255, 255, 255, 0.02)",
        border: "1px solid var(--rail)",
        padding: "20px",
        marginTop: "8px",
      }}
    >
      <label
        style={{
          display: "flex",
          alignItems: "flex-start",
          gap: "14px",
          cursor: disabled ? "not-allowed" : "pointer",
          opacity: disabled ? 0.6 : 1,
        }}
      >
        <input
          type="checkbox"
          checked={checked}
          onChange={(e) => onChange(e.target.checked)}
          disabled={disabled}
          required
          style={{
            width: "20px",
            height: "20px",
            marginTop: "2px",
            accentColor: "var(--accent)",
            cursor: disabled ? "not-allowed" : "pointer",
            flexShrink: 0,
          }}
        />
        <span style={{ color: "var(--text)", lineHeight: 1.5, fontSize: "0.95rem" }}>
          I agree to receive SMS notifications from Sales Demon about my account, invoices,
          payments, and business operations.
        </span>
      </label>

      <p
        style={{
          color: "var(--muted)",
          fontSize: "0.8rem",
          lineHeight: 1.6,
          marginTop: "14px",
          marginLeft: "34px",
        }}
      >
        Message frequency varies based on account activity. Message and data rates may apply.
        Reply STOP to unsubscribe or HELP for help. View our{" "}
        <Link
          to="/legal/sms-terms"
          style={{ color: "var(--accent-text)", textDecoration: "underline" }}
          target="_blank"
          rel="noopener noreferrer"
        >
          SMS Terms
        </Link>{" "}
        and{" "}
        <Link
          to="/legal/privacy"
          style={{ color: "var(--accent-text)", textDecoration: "underline" }}
          target="_blank"
          rel="noopener noreferrer"
        >
          Privacy Policy
        </Link>
        .
      </p>
    </div>
  )
}
